"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unexpectedCodepath = unexpectedCodepath;
function unexpectedCodepath(msg, logger) {
    var baseMessage = 'ERROR: Unexpected Codepath Reached';
    var errorMessage = "".concat(baseMessage, " - ").concat(msg);
    logger.error(errorMessage);
}
